import React from 'react';
import {StyleProp, Text, TextStyle, View, ViewStyle} from 'react-native';
import {styles} from './styles';

interface Props {
  title: string;
  type?: string;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
}

const Label = ({title, type, style, textStyle}: Props) => {
  return (
    <View style={style}>
      {type && type === 'mainTitle' && (
        <Text style={[styles.mainTitle, textStyle]}>{title}</Text>
      )}
      {type && type === 'secondTitle' && (
        <Text style={[styles.secondTitle, textStyle]}>{title}</Text>
      )}
      {type && type === 'thirdTitle' && (
        <Text style={[styles.thirdTitle, textStyle]}>{title}</Text>
      )}
      {type && type === 'fourthTitle' && (
        <Text style={[styles.paragraph14, styles.textItalic, textStyle]}>
          {title}
        </Text>
      )}
      {type && type === 'titleGreen' && (
        <Text style={[styles.titleGreen, textStyle]}>{title}</Text>
      )}
      {type && type === 'titleGreenCross' && (
        <Text style={[styles.titleGreenCross, textStyle]}>{title}</Text>
      )}
      {type && type === 'titleGreenCenter' && (
        <Text style={[styles.titleGreenCenter, textStyle]}>{title}</Text>
      )}
      {type && type === 'titleGreen11' && (
        <Text style={[styles.titleGreen11, textStyle]}>{title}</Text>
      )}
      {type && type === 'titleGreen12' && (
        <Text style={[styles.titleGreen12, textStyle]}>{title}</Text>
      )}
      {type && type === 'titleGreen13' && (
        <Text style={[styles.titleGreen13, textStyle]}>{title}</Text>
      )}
      {type && type === 'titleGreen14' && (
        <Text style={[styles.titleGreen14, textStyle]}>{title}</Text>
      )}
      {type && type === 'paragraph' && (
        <Text style={[styles.paragraph, textStyle]}>{title}</Text>
      )}
      {type && type === 'paragraph14' && (
        <Text style={[styles.paragraph14, textStyle]}>{title}</Text>
      )}
      {type && type === 'link' && (
        <Text style={[styles.link, textStyle]}>{title}</Text>
      )}
      {type && type === 'linkblue' && (
        <Text style={[styles.linkblue, textStyle]}>{title}</Text>
      )}
      {type && type === 'linkUnderline' && (
        <Text style={[styles.linkUnderline, textStyle]}>{title}</Text>
      )}
      {type && type === 'error' && (
        <Text style={[styles.error, textStyle]}>{title}</Text>
      )}
      {!type && <Text style={[styles.label, textStyle]}>{title}</Text>}
    </View>
  );
};

export default Label;
